import React from 'react';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight, FaStar } from 'react-icons/fa';
import { reviews as defaultReviews } from '../data/reviews';
import './Reviews.css';

const NextArrow = ({ onClick }) => (
  <div className="reviews-arrow next-arrow" onClick={onClick}><FaChevronRight /></div>
);

const PrevArrow = ({ onClick }) => (
  <div className="reviews-arrow prev-arrow" onClick={onClick}><FaChevronLeft /></div>
);

function StarRating({ rating = 5 }) {
  const stars = Math.min(5, Math.max(0, Math.round(rating)));
  return (
    <div className="review-stars" aria-label={`${stars} из 5`}>
      {[...Array(5)].map((_, i) => (
        <FaStar key={i} className={i < stars ? 'is-filled' : 'is-empty'} />
      ))}
    </div>
  );
}

function Reviews({ reviews = defaultReviews }) {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="reviews-section page-section">
      <div className="page-container">
        <h2 className="section-title">Отзывы клиентов</h2>
        <p className="section-subtitle">
          Нам доверяют путешественники по всему Узбекистану.
        </p>

        <div className="reviews-carousel">
          <Slider {...sliderSettings}>
            {reviews.map((review) => (
              <div key={review.name}>
                <article className="review-card">
                  <StarRating rating={review.rating ?? 5} />
                  <p className="review-text">«{review.text}»</p>
                  <div className="review-author">
                    <strong>{review.name}</strong>
                    <span>
                      {review.city || review.origin}
                      {review.tour ? ` · ${review.tour}` : ''}
                    </span>
                    {review.manager && (
                      <span className="review-manager">Менеджер: {review.manager}</span>
                    )}
                  </div>
                </article>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Reviews;
